import type { GeoPointContent } from "@prismicio/types-internal/lib/content"

type Coordinates = GeoPointContent["position"]

function validateCoordinates(latLng: Coordinates) {
  return !(
    latLng.lat > 85 ||
    latLng.lat < -85 ||
    latLng.lng > 180 ||
    latLng.lng < -180
  )
}

export function parseGoogleMapsUrl(url: string): Coordinates | undefined {
  const urlLatLongRegex = /^.*@(-?\d+.\d+),(-?\d+.\d+).*$/
  const matched = url.match(urlLatLongRegex)

  if (!matched) return

  const latitude = parseFloat(matched[1] ?? "")
  const longitude = parseFloat(matched[2] ?? "")

  if (isNaN(latitude) || isNaN(longitude)) return

  const coordinates = { lat: latitude, lng: longitude }

  if (!validateCoordinates(coordinates)) return

  return coordinates
}

export function coordinatesToString(coordinates?: Coordinates) {
  if (!coordinates) return ""

  return `${coordinates.lat}, ${coordinates.lng}`
}

export function parseString(str: string): Coordinates | undefined {
  const latLongRegex = /\(?([\d|.|-]*)[\s+]*,[\s]*([\d|.|-]*)\)?/
  const matched = str.match(latLongRegex)

  if (!matched) return parseGoogleMapsUrl(str)

  const latitude = parseFloat(matched[1] ?? "")
  const longitude = parseFloat(matched[2] ?? "")

  if (isNaN(latitude) || isNaN(longitude)) return parseGoogleMapsUrl(str)

  const coordinates = { lat: latitude, lng: longitude }

  if (!validateCoordinates(coordinates)) return parseGoogleMapsUrl(str)

  return coordinates
}
